import React, { useEffect, useState } from 'react';
import BannerImage from '../Components/login-components/banner-image/BannerImage';
import LogoContainer from '../Components/login-components/logo-container/LogoContainer';
import MsHome from '../Components/Maruti-Suzuki-components/MsHome';
import BottomCard from '../Components/login-components/bottom-card/BottomCard';
// import CommonButton from '../Components/global-components/CommonButton/CommonButton';
// import Loadingoverlay from '../Components/global-components/LoadingOverlay/Loadingoverlay';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { activeStepper } from '../Screens/Redux/stepperSlice';
import { showGlobalError } from '../Screens/Redux/globalErrorSlice';
import CommonDropDown from '../Components/global-components/CommonDropDown/CommonDropDown';
const CDDForm = () => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        aadharNumber: '',
        voterIdNumber: '',
        drivingLicenceNumber: '',
        passportNumber: '',
        existingKycNumber: '',
        beneficialOwnershipDetails: '',
    });
    const location = useLocation()
    const [industryType, setIndustryType] = useState()
    const [organisationType, setOrganizationType] = useState();
    const [beneficialOwnership, setBeneficialOwnership] = useState("No");
    const [politicallyExposed, setPoliticallyExposed] = useState("No");
    const industryOptions = [
        "--select--",
        "Jewelry",
        "Import-Export",
        "Mining",
        "Shipping",
        "Scrap Dealing",
        "Real Estate",
        "Agriculture",
        "Stock Broking",
        "BFSI",
        "Manufacturing",
        "Other",
    ];
    const organisationTypeList = [
        "--select--",
        "Government",
        "Private Limited",
        "Public Limited",
        "Trust",
        "Other",
    ];
    const {
        // name,
        // panNumber,
        // doi,
        permanentAddress,
        permanentCity,
        permanentState,
        permanentPincode,
        correspondenceAddressLineOne,
        correspondenceAddressLineTwo,
        correspondenceState,
        correspondenceCity,
        correspondencePincode,
    } = useSelector((state) => state.corporateSlice.userData);
    const attachedFieldOptions = [
        "--select--",
        'Aadhaar / Mask Aadhaar',
        'Voter ID',
        'Driving License (DL)',
        'Passport'
    ];
    const kycId = useSelector((state) => state.corporateSlice.addNewKycId);
    const { reason, panTypeError } = useSelector((state) => state.ExceptionReasonSlice);    
    const [selectedAttachedField, setSelectedAttachedField] = useState("");
    const [errors, setErrors] = useState({
        industryType: '',
        organisationType: '',
        attachedFieldDropdown: '',
        attachedField: '',
        existingKycNumber: '',
        pep_flag: '',
        beneficialOwnership: '',
        beneficialOwnershipDetails: '',
    });
    const { mi_u, channelUrl } = useSelector(
        (state) => state.partnerChannelNameSlice.marutiUserDetails
      );
    const navigate = useNavigate();
 
    const handleChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
        setErrors(prev => ({ ...prev, [key]: '' })); // clear error when typing
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};
        if (!industryType) {
            newErrors.industryType = 'Industry Type is required.';
        }
        if (!organisationType) {
            newErrors.organisationType = 'Organisation Type is required.';
        }
        if (!selectedAttachedField) {
            newErrors.attachedFieldDropdown = 'This field is required';
        }
        if (beneficialOwnership === "Yes" && formData.beneficialOwnershipDetails == "") {
            newErrors.beneficialOwnershipDetails = "Ownership details are required"
        }
        else {
            const val = formData[selectedAttachedField] || '';
            if (selectedAttachedField === 'Aadhaar / Mask Aadhaar') {
                if (!/^\d{4}$/.test(val)) {
                    newErrors.attachedField = 'Aadhaar must be exactly 4 digits.';
                }
            } else {
                if (val.length < 4 || val.length > 40) {
                    newErrors.attachedField = 'Must be between 4 and 40 characters.';
                }
            }
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            console.log('Validation failed:', newErrors);
            return;
        }
        const selectedAttachedFieldkey = selectedAttachedField == "Aadhaar / Mask Aadhaar" ? "aadharNumber" : selectedAttachedField == "Voter ID" ? "voterIdNumber" : selectedAttachedField == "Driving License (DL)" ? "drivingLicenceNumber" : selectedAttachedField == "Passport" ? "passportNumber" : ""
        const payload = {
            channel: channelUrl || "",
            txnId: mi_u || "",
            kyc_id: kycId || location?.state?.kyc_ref_id,
            pan_type_error: panTypeError || "",
            pan_reason: reason || "",
            permanentAddress,
            permanentCity,
            permanentState,
            permanentPincode,
            correspondenceAddressOne:correspondenceAddressLineOne,
            correspondenceAddressTwo:correspondenceAddressLineTwo,
            correspondenceState,
            correspondenceCity,
            correspondencePincode,
            beneficialOwnership: beneficialOwnership === "Yes" ? true : false,
            existingKycNumber: formData.existingKycNumber,
            industryType: industryType,
            organisationType: organisationType,
            isCDD:true,
            pep_flag: politicallyExposed === "Yes" ? true : false,
            [selectedAttachedFieldkey]: formData[selectedAttachedField],
            beneficialOwnershipDetails:
                beneficialOwnership === "Yes"
                    ? formData.beneficialOwnershipDetails
                    : '',
        };
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/customer/update-customer-meta?token=${localStorage.getItem("token")}`,
                payload,
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            dispatch(activeStepper(3));
            navigate('/Success', {
                state: {
                    kyc_ref_id: response?.data?.data?.kyc_id,
                    successUrl: response?.data?.data?.success_url,
                    isRouteAllowed: true,
                    typeOfKyc: "ovd",
                }
 
            });
        } catch (error) {
            dispatch(showGlobalError(error.response.data.message));
            console.error('Error:', error);
        }
    };
 
    useEffect(() => {
        dispatch(activeStepper(2));
    }, []);
 
    useEffect(() => {
        if (industryType) {
            setErrors((prev) => ({ ...prev, industryType: "" }))
        }
        if (organisationType) {
            setErrors((prev) => ({ ...prev, organisationType: "" }))
        }
        if (selectedAttachedField) {
            setErrors((prev) => ({ ...prev, attachedFieldDropdown: "" }))
        }
    }, [industryType, organisationType, selectedAttachedField])

    useEffect(() => {
        if (selectedAttachedField == 'Aadhaar / Mask Aadhaar') {
            setFormData((prev) => ({ ...prev, "Passport": "", "Voter ID":"", "Driving License (DL)":"" }))
        }
        if (selectedAttachedField == 'Voter ID') {
            setFormData((prev) => ({ ...prev, "Passport": "", "Aadhaar / Mask Aadhaar":"", "Driving License (DL)":"" }))
        }
        if (selectedAttachedField == 'Passport') {
            setFormData((prev) => ({ ...prev, "Aadhaar / Mask Aadhaar": "", "Voter ID":"", "Driving License (DL)":"" }))
        }
        if (selectedAttachedField == 'Driving License (DL)') {
            setFormData((prev) => ({ ...prev, "Aadhaar / Mask Aadhaar": "", "Voter ID":"", "Passport":"" }))
        }
    }, [formData[selectedAttachedField]]) 
    return (
        <>
            {/* <Loadingoverlay /> */}
            <BannerImage>
                <LogoContainer />
            </BannerImage>
            <MsHome>
                <div className="md:h-full md:overflow-hidden ">
                    <BottomCard stepper={true}>
                        <form onSubmit={handleSubmit} className="h-full overflow-y-scroll p-2 space-y-4">
                            <div>
                                <CommonDropDown
                                    options={industryOptions}
                                    selected={industryType}
                                    setSelected={setIndustryType}
                                    label={"Industry Type"}
                                />
                                {errors.industryType && <p className="text-red-500 text-sm mt-1">{errors.industryType}</p>}
                            </div>
                            <div>
                                <CommonDropDown
                                    options={organisationTypeList}
                                    selected={organisationType}
                                    setSelected={setOrganizationType}
                                    label={"Organisation Type "}
                                />
                                {errors.organisationType && <p className="text-red-500 text-sm mt-1">{errors.organisationType}</p>}
                            </div>
                            <div>
                                <CommonDropDown
                                    options={attachedFieldOptions}
                                    selected={selectedAttachedField}
                                    setSelected={setSelectedAttachedField}
                                    label={"Capturing of attached field"}
                                />
                                {errors.attachedFieldDropdown && <p className="text-red-500 text-sm mt-1">{errors.attachedFieldDropdown}</p>}
                            </div>
                            {selectedAttachedField && (
                                <div className="mt-2">
                                    <label className="block mb-1 font-medium text-gray-700">
                                        {attachedFieldOptions.find((opt) => opt === selectedAttachedField)}<span className='text-red-500'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={formData[selectedAttachedField]}
                                        onChange={(e) => {
                                            let val = e.target.value;
                                            if (selectedAttachedField === 'Aadhaar / Mask Aadhaar') {
                                                val = val.replace(/\D/g, '');
                                                if (val.length > 4) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Aadhaar must be exactly 4 digits.' }));
                                                    return
                                                }
                                                else if (val.length < 4) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Aadhaar must be exactly 4 digits.' }));
                                                }
                                                else {
                                                    setErrors(prev => ({ ...prev, attachedField: '' }));
                                                }
                                            } else {
                                                val = val.toUpperCase();
                                                if (val.length < 4) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Minimun 4 characters are required' }));
                                                }
                                                else if (val.length > 40) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Maximum 40 characters are allowed' }));
                                                    return
                                                }
                                                if (val.length >= 4 && val.length <= 40) {
                                                    setErrors(prev => ({ ...prev, attachedField: '' }));
                                                }
                                            }
                                            handleChange(selectedAttachedField, val);
                                        }}
                                        onBlur={() => {
                                            const val = formData[selectedAttachedField] || '';
                                            if (selectedAttachedField === 'Aadhaar / Mask Aadhaar') {
                                                if (val.length !== 4) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Aadhaar must be exactly 4 digits.' }));
                                                } else {
                                                    setErrors(prev => ({ ...prev, attachedField: '' }));
                                                }
                                            } else {
                                                if (val.length < 4) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Minimun 4 characters are required' }));
                                                }
                                                else if (val.length > 40) {
                                                    setErrors(prev => ({ ...prev, attachedField: 'Maximum 40 characters are allowed' }));
                                                    return
                                                } else {
                                                    setErrors(prev => ({ ...prev, attachedField: '' }));
                                                }
                                            }
                                        }}
                                        className="w-full h-[44px] rounded-md px-3 py-2 focus:outline-none"
 
                                    />
                                    {errors.attachedField && (
                                        <p className="text-red-500 text-sm mt-1">{errors.attachedField}</p>
                                    )}
                                </div>
                            )}
                            {/* Existing KYC Number (optional, add validation if needed) */}
                            <div>
                                <label className="block mb-1 font-medium text-black-500">Existing KYC Number (if any)</label>
                                <input
                                    type="text"
                                    value={formData.existingKycNumber}
                                    onChange={(e) => handleChange('existingKycNumber', e.target.value)}
                                    className="w-full h-[44px] rounded-md px-3 py-2 focus:outline-none "
                                />
                            </div>
                            {/* PEP */}
                            <div>
                                <CommonDropDown
                                    options={["--select--", "No", "Yes"]}
                                    selected={politicallyExposed}
                                    setSelected={setPoliticallyExposed}
                                    label={"Are you a Politically Exposed Person (PEP)?"}
                                />
                                <i className="text-xs font-medium text-black">
                                    "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
                                </i>
                            </div>
                            <div>
                                <CommonDropDown
                                    options={["--select--", "No", "Yes"]}
                                    selected={beneficialOwnership}
                                    setSelected={setBeneficialOwnership}
                                    label={"Beneficial Ownership"}
                                />
                            </div>
                            {beneficialOwnership === "Yes" && (
                                <div>
                                    <label className="block mb-1 font-medium text-black-500">Beneficial Ownership Details <span className='text-red-500'>*</span></label>
                                    <input
                                        type="text"
                                        value={formData.beneficialOwnershipDetails}
                                        onChange={(e) => handleChange('beneficialOwnershipDetails', e.target.value)}
                                        className="w-full h-[44px] rounded-md px-3 py-2 focus:outline-none "
                                    />
                                    {errors.beneficialOwnershipDetails && <p className="text-red-500 text-sm mt-1">{errors.beneficialOwnershipDetails}</p>}
                                </div>
                            )}
                            <button
                                type="submit"
                                className="inline-flex w-full outline-none items-center py-2 px-3 text-sm font-medium text-center text-white rounded-md border focus:outline-none bg-primaryH justify-center"
                            >
                                Submit
                            </button>
                        </form>
                    </BottomCard>
                </div>
            </MsHome>
        </>
    );
};
export default CDDForm;
 